// Fine-grained API token types and enums
export var ApiTokenScopeResourceType;
(function (ApiTokenScopeResourceType) {
    ApiTokenScopeResourceType["BASE"] = "base";
    ApiTokenScopeResourceType["WORKSPACE"] = "workspace";
})(ApiTokenScopeResourceType || (ApiTokenScopeResourceType = {}));
export var ApiTokenPermissionLevel;
(function (ApiTokenPermissionLevel) {
    ApiTokenPermissionLevel["NONE"] = "none";
    ApiTokenPermissionLevel["READ"] = "read";
    ApiTokenPermissionLevel["WRITE"] = "write";
})(ApiTokenPermissionLevel || (ApiTokenPermissionLevel = {}));
// Permission category keys — granular per resource type
export var ApiTokenPermissionCategory;
(function (ApiTokenPermissionCategory) {
    ApiTokenPermissionCategory["RECORDS"] = "records";
    ApiTokenPermissionCategory["TABLES"] = "tables";
    ApiTokenPermissionCategory["FIELDS"] = "fields";
    ApiTokenPermissionCategory["VIEWS"] = "views";
    ApiTokenPermissionCategory["BASE"] = "base";
    ApiTokenPermissionCategory["COMMENTS"] = "comments";
    ApiTokenPermissionCategory["WEBHOOKS"] = "webhooks";
    ApiTokenPermissionCategory["USERS"] = "users";
})(ApiTokenPermissionCategory || (ApiTokenPermissionCategory = {}));
// Base-scoped permission categories
export const BASE_SCOPED_PERMISSION_CATEGORIES = [
    ApiTokenPermissionCategory.RECORDS,
    ApiTokenPermissionCategory.TABLES,
    ApiTokenPermissionCategory.FIELDS,
    ApiTokenPermissionCategory.VIEWS,
    ApiTokenPermissionCategory.BASE,
    ApiTokenPermissionCategory.COMMENTS,
    ApiTokenPermissionCategory.WEBHOOKS,
    ApiTokenPermissionCategory.USERS,
];
// Permission categories grouped for UI display
export const API_TOKEN_PERMISSION_GROUPS = {
    Data: [
        ApiTokenPermissionCategory.RECORDS,
        ApiTokenPermissionCategory.COMMENTS,
    ],
    Schema: [
        ApiTokenPermissionCategory.TABLES,
        ApiTokenPermissionCategory.FIELDS,
        ApiTokenPermissionCategory.VIEWS,
    ],
    Tools: [ApiTokenPermissionCategory.WEBHOOKS],
    Admin: [ApiTokenPermissionCategory.BASE, ApiTokenPermissionCategory.USERS],
};
export const API_TOKEN_PREFIX = 'nc_pat_';
// Preset permission configurations for UI
export const API_TOKEN_PERMISSION_PRESETS = {
    readOnly: {
        records: ApiTokenPermissionLevel.READ,
        tables: ApiTokenPermissionLevel.READ,
        fields: ApiTokenPermissionLevel.READ,
        views: ApiTokenPermissionLevel.READ,
        base: ApiTokenPermissionLevel.READ,
        comments: ApiTokenPermissionLevel.READ,
        webhooks: ApiTokenPermissionLevel.NONE,
        users: ApiTokenPermissionLevel.NONE,
    },
    fullDataAccess: {
        records: ApiTokenPermissionLevel.WRITE,
        tables: ApiTokenPermissionLevel.NONE,
        fields: ApiTokenPermissionLevel.NONE,
        views: ApiTokenPermissionLevel.NONE,
        base: ApiTokenPermissionLevel.NONE,
        comments: ApiTokenPermissionLevel.WRITE,
        webhooks: ApiTokenPermissionLevel.NONE,
        users: ApiTokenPermissionLevel.NONE,
    },
};
//# sourceMappingURL=data:application/json;base64,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